import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import PageBanner from '@components/Common/PageBanner';
import Lightbox from '@components/Common/Lightbox';
import RightClickProtection from '@components/Common/RightClickProtection';
import Testimonials from '@components/Common/Testimonials';
import { interiorPortfolioImages } from '@data/interiorPortfolio';
import './InteriorWork.css';

const InteriorWork = () => {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    // Handle lightbox open
    const handleImageClick = (index) => {
        setCurrentImageIndex(index);
        setLightboxOpen(true);
    };

    // Handle lightbox close
    const handleLightboxClose = () => {
        setLightboxOpen(false);
        setCurrentImageIndex(0);
    };

    // Convert portfolio images to lightbox format
    const lightboxImages = interiorPortfolioImages.map(img => img.src);

    return (
        <RightClickProtection>
            <Helmet>
                <title>Interior Design Portfolio - AT Architects</title>
                <meta
                    name="description"
                    content="Discover our interior design portfolio featuring residential and commercial interiors with innovative aesthetics."
                />
                <meta property="og:title" content="Interior Design Portfolio - AT Architects" />
                <meta property="og:description" content="Our interior design projects" />
                <link rel="canonical" href="https://atarchitects.com/interior-work" />
            </Helmet>

            <PageBanner
                title="Interior Design Portfolio"
                subtitle="Crafting spaces that inspire and delight"
                backgroundImage="/images/interior-portfolio/hero-interior.png"
            />

            <section className="portfolio-section">
                <div className="portfolio-container">
                    {/* Portfolio Grid */}
                    <motion.div
                        className="portfolio-grid"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        {interiorPortfolioImages.map((item, index) => (
                            <motion.div
                                key={index}
                                className="portfolio-item"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.3, delay: index * 0.05 }}
                                onClick={() => handleImageClick(index)}
                            >
                                <div className="portfolio-image-wrapper">
                                    <img
                                        src={item.src}
                                        alt={item.caption}
                                        className="portfolio-image"
                                        loading="lazy"
                                    />
                                    <div className="portfolio-overlay">
                                        <h3 className="portfolio-caption">{item.caption}</h3>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </section>

            {/* Lightbox */}
            {lightboxOpen && (
                <Lightbox
                    images={lightboxImages}
                    currentIndex={currentImageIndex}
                    onClose={handleLightboxClose}
                />
            )}

            <Testimonials />
        </RightClickProtection>
    );
};

export default InteriorWork;
